import React from "react";

export default function ToonControls({
  Slider,

  bands,
  setBands,
}) {
  return (
    <Slider
      label="Bands"
      value={bands}
      min={2}
      max={8}
      step={1}
      display={bands.toString()}
      onChange={setBands}
    />
  );
}
